import { Node, mergeAttributes } from '@tiptap/core'
import { VueNodeViewRenderer } from '@tiptap/vue-3'
import ConsentVariableNodeView from './ConsentVariableNodeView.vue'
import { CONSENT_VARIABLE_NODE_NAME } from './consentWording'

export interface ConsentVariableOptions {
  HTMLAttributes: Record<string, unknown>
  getLabel: (name: string) => string
}

declare module '@tiptap/core' {
  interface Commands<ReturnType> {
    consentVariable: {
      insertConsentVariable: (name: string, label?: string) => ReturnType
    }
  }
}

export const ConsentVariable = Node.create<ConsentVariableOptions>({
  name: CONSENT_VARIABLE_NODE_NAME,

  group: 'inline',

  inline: true,

  selectable: true,

  atom: true,

  addOptions() {
    return {
      HTMLAttributes: {},
      getLabel: (name: string) => name
    }
  },

  addAttributes() {
    return {
      name: {
        default: null,
        parseHTML: (element) => element.getAttribute('data-variable'),
        renderHTML: (attributes) => ({ 'data-variable': attributes.name })
      },
      label: {
        default: null,
        parseHTML: (element) => element.getAttribute('data-label'),
        renderHTML: (attributes) => (attributes.label ? { 'data-label': attributes.label } : {})
      }
    }
  },

  parseHTML() {
    return [
      {
        tag: 'span[data-variable]'
      }
    ]
  },

  renderHTML({ node, HTMLAttributes }) {
    return [
      'span',
      mergeAttributes(this.options.HTMLAttributes, HTMLAttributes, { class: 'variable-node' }),
      node.attrs.label || this.options.getLabel(node.attrs.name)
    ]
  },

  addNodeView() {
    return VueNodeViewRenderer(ConsentVariableNodeView)
  },

  addCommands() {
    return {
      insertConsentVariable:
        (name: string, label?: string) =>
        ({ commands }) => {
          return commands.insertContent([
            {
              type: this.name,
              attrs: { name, label: label || null }
            },
            { type: 'text', text: ' ' }
          ])
        }
    }
  }
})
